import React, { Component } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import classnames from 'classnames';

import DateTime from 'react-datetime';
import moment from 'moment';

class OroDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.setDate = this.setDate.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  isValid(selectedDate){
    var date = new Date();
    return selectedDate.isBefore(date);
  };

  setDate(date) {
    this.setState({
      dob: date,
      formattedDob: typeof date === 'string' ? date : date.format("MMMM D, YYYY")
    }, () => {
      this.props.onDateUpdated(this.state)
    });
  }

  render() {
    return (
      <FormGroup>
        <Label for="dob" 
                className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.dob })} >
                {this.props.label}
        </Label>

        <DateTime 
            inputProps={ {
              placeholder: this.props.label,
              readOnly: true
            } }
            closeOnSelect={true}
            value={this.state.formattedDob}
            onChange={this.setDate}
            isValidDate={ this.isValid}
            />
      </FormGroup>
    );
  }
}

export default OroDatePicker; 